import {
  getPanelSession, hasAdminAccess, hasFinanceAccess, hasPanelAccess,
} from './panelSession'

export default function canAccessScope(scope = 'panel', session = getPanelSession()) {
  if (scope === 'admin') return hasAdminAccess(session)
  if (scope === 'finance') return hasFinanceAccess(session)

  return scope === 'panel' && hasPanelAccess(session)
}
